import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { LibFormContainerModule } from '../form-container/form-container.module';
import { PasswordResetFinishComponent } from './finish/password-reset-finish.component';
import { PasswordResetInitComponent } from './init/password-reset-init.component';
import { InscriptionFinishComponent } from './inscription-finish/inscription-finish.component';

@NgModule({
    imports: [CommonModule, FormsModule, LibFormContainerModule, MatButtonModule, MatFormFieldModule, MatInputModule],
    declarations: [PasswordResetInitComponent, PasswordResetFinishComponent, InscriptionFinishComponent],
})
export class LibPasswordResetModule {}
